<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Process Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`${prep_process.name} Process`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['read prep process']">
      <template #gated-content>
        <b-row class="mb-3">
          <b-col cols="6">
            <b-table-simple borderless striped>
              <b-tbody>
                <b-tr></b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Name</b-th>
                  <b-td class="w-100">{{ prep_process.name }}</b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-nowrap">Description</b-th>
                  <b-td class="w-100">{{ prep_process.description }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>
      </template>
    </permission-alert-gate>

    <permission-alert-gate :permissions="['list prep task']">
      <template #gated-content>
        <div>
          <h3>
            Tasks
            <b-button class="float-right" variant="success" :to="`/${route_root}/${sample_type_id}/${prep_process_id}/add`">
              <i class="fal fa-plus" />
            </b-button>
          </h3>
        </div>

        <WorkflowPrepTaskServerTable :sample_type_id="sample_type_id" :prep_process_id="prep_process_id" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import { getModel } from '@/shared/fetch-utils'
import WorkflowPrepTaskServerTable from '@/components/lab/workflows/prep/WorkflowPrepTaskServerTable'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

export default {
  name: 'WorkflowPrepProcessDetail',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    WorkflowPrepTaskServerTable
  },
  data () {
    return {
      loading: true,
      sample_type_id: this.$route.params.sample_type_id || null,
      prep_process_id: this.$route.params.prep_process_id || null,
      prep_process: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-search",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/audit-trail`,
            title: "Audit Trail",
            variant: "dark",
          },
          {
            icon: "fa-pencil",
            title: "Edit sample",
            variant: "warning",
            linkto: `/${this.route_root}/${this.sample_type_id}/${this.prep_process_id}/edit`
          }
        ]
      }
    },

    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  async mounted () {
    this.loading = true

    this.prep_process = await getModel({
      model_type: 'prep_process',
      id: this.prep_process_id,
      message: this.$bvToast
    })

    this.prep_process ? (this.loading = false) : this.$router.back()
  }
}
</script>
